export var CommercialFeatureFlags;
(function (CommercialFeatureFlags) {
    CommercialFeatureFlags["Embedding"] = "embedding";
    CommercialFeatureFlags["Scim"] = "scim-token-management";
    CommercialFeatureFlags["AiCopilot"] = "ai-copilot";
    CommercialFeatureFlags["AiAgent"] = "ai-agent";
    CommercialFeatureFlags["ServiceAccounts"] = "service-accounts";
})(CommercialFeatureFlags || (CommercialFeatureFlags = {}));
//# sourceMappingURL=commercialFeatureFlags.js.map